import React from "react";
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import MyButton from "../myButton";


const MySearch = ({label, values, valuesSelects, onSelect, getOptions, maximoSelecionados}) => {

    const [open, setOpen] = useState(false);
    const [valueSelected, setValueSelected] = useState(null);
    const [options, setOptions] = useState([]);
    const loading = open && values.length === 0;

    const _setOptions = () =>{
        let _values = values.filter(item => valuesSelects?.filter(item2 => item.id === item2.id).length <= 0)
        setOptions([..._values]);
    }

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {

        if (active) {
            await getOptions();
        }
        })();

        return () => {
        active = false;
        };
    }, [loading]);

    useEffect(() => {
        if (open) {
            _setOptions()
        }
    }, [values]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
        else {
            _setOptions()
        }
    }, [open]);

    return (
        <Box sx={{display:'flex'}}>
            <Box sx={{flexGrow:1, marginRight:'10px',}}>
                <Autocomplete
                    size='small'
                    id={label}
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    value={valueSelected}
                    onChange={(event, newValue) => {
                        setValueSelected(newValue);
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    options={options}
                    loading={loading}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                        />
                    )}
                />
            </Box>
            <Box sx={{width:'122px'}}>
                <MyButton onClick={()=> {
                    if (valueSelected){
                        onSelect(valueSelected)
                    }
                    }} variant='contained' text='Adicionar' color='secondary' disabled={maximoSelecionados === null ? false : valuesSelects.length >= maximoSelecionados}/>
            </Box>
        </Box>
    )
}

export default MySearch